function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M176.259,0c-76.645,0-139,62.355-139,139c0,28.248,8.428,55.441,24.374,78.639c14.717,21.411,34.875,38.124,58.495,48.551 l45.251,79.983c2.218,3.921,6.375,6.345,10.879,6.345s8.661-2.424,10.879-6.345l45.251-79.983 c23.62-10.427,43.778-27.14,58.495-48.551c15.948-23.197,24.376-50.391,24.376-78.639C315.259,62.355,252.903,0,176.259,0z  M218.923,244.742c-2.621,1.06-4.807,2.976-6.198,5.436l-36.466,64.455l-36.466-64.455c-1.392-2.46-3.577-4.376-6.198-5.436 C90.26,227.238,62.259,185.732,62.259,139c0-62.86,51.14-114,114-114c62.86,0,114,51.14,114,114 C290.259,185.732,262.258,227.238,218.923,244.742z"
}), React.createElement("path", {
  d: "M176.259,85.759c-28.949,0-52.5,23.551-52.5,52.5s23.551,52.5,52.5,52.5s52.5-23.551,52.5-52.5 S205.208,85.759,176.259,85.759z M176.259,165.759c-15.164,0-27.5-12.336-27.5-27.5s12.336-27.5,27.5-27.5s27.5,12.336,27.5,27.5 S191.423,165.759,176.259,165.759z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352.518 352.518",
    style: {
      enableBackground: "new 0 0 352.518 352.518"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.bc56001b.svg";
export { ForwardRef as ReactComponent };